import React from 'react';
import "../../../styleSheets/Checkbox.scss";
import "../../../styleSheets/CustomInput.scss";
import {
  themeColors,
  gradients,
} from '../../../constants'
import "../../../styleSheets/userSummaryLabel.scss";
import styles from './LogMessageLabel.module.scss'
import {
  Svg,
  ColorBlock,
  Image,
} from '../../../components'

const UserSummaryLabel = (props) => {
  let object = props.object

  let icon;
  let color;
  switch(object.category) {
    case 'create_payment':
      icon = 'add'
      color = gradients.brandGreen
      break;
    case 'create_paid_back_payment':
      icon = 'add'
      color = gradients.brandGreen
      break;
    case 'update_payment':
      icon = 'edit'
      color = gradients.brandGold
      break;
    case 'delete_payment':
      icon = 'delete'
      color = gradients.brandRed
      break;
    case 'edit_accounting_book':
      icon = 'edit'
      color = gradients.brandGold
      break;
    default:
      color = themeColors.green700
      break;

  }

  return (
    <>
      <label className={styles.label}>
        <div className={styles.img}>
          <Image size='56px' imageUrl={object.user_image_url}/>
          <ColorBlock
            color={color}
            imageSize='24px'
            blockStyle={{
              position: 'absolute',
              top: 33,
              right: 0,
            }}>
            <Svg icon={icon} size='16' className='white'/>
          </ColorBlock>
        </div>
        <div className={styles.content}>
          <div className={styles.category}>
            {object.user_name + object.display_category}
          </div>
          <div className={styles.message}>
            {object.content}
          </div>
          <div className={styles.time}>
            {object.created_at}
          </div>
        </div>
      </label>
    </>
  )
};

export default UserSummaryLabel;
